export default __webpack_public_path__ + "static/media/home-photography-img-01.58e8107c.jpg";